<li class="list-group-item placement"><slot></slot><CheckboxIcon :checked="!!(issueId || pageId)"></CheckboxIcon>
<strong v-if="issueId || pageId">{{ publicationName }}</strong><span class="text-muted" v-else>None selected</span>
<template v-if="issueId"><i class="fa fa-angle-right"></i>
<i class="fa fa-newspaper-o"></i>
{{ issueTitle }}

</template><template v-if="pageId"><i class="fa fa-angle-right"></i>
<i class="fa fa-file-o"></i>

{{ pageTitle }}</template></li>